export enum MrloAnalysisType {
  FATF = 1,
  Sanctioned = 2,
  Prohibited = 3,
  Corruption = 4,
  Terrorism = 5,
}
